/* eslint-disable
    new-cap
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

import SecondaryStructure from 'analyses/SecondaryStructure';
import SecondaryStructureTabState from 'analyses/SecondaryStructureTabState';
import SecondaryStructureTabTemplate from 'analyses/SecondaryStructureTabTemplate';

class OptionsView extends Backbone.View<SecondaryStructureTabState> {}

class TabView extends Backbone.View<SecondaryStructureTabState> {
  structures!: Array<SecondaryStructure>;

  static initClass(): void {
    this.prototype.className = 'all-secondary-structures buffer-tab';
    // @ts-expect-error: Backbone events can be either the events hash or a method returning the events hash
    // The Backbone types do not know about this.
    this.prototype.events = {'click tbody > tr': 'openStructure'};
  }

  openStructure(e: JQueryEventObject): void {
    const index = $(e.currentTarget).data('index');
    this.structures[index].showModal();
  }

  override render(): this {
    const mainStructure = this.model.get('mainStructure');
    this.structures = this.model
      .get('structures')
      .filter((model: SecondaryStructure) => model.get('dg') > mainStructure.get('dg')); // in case ViennaRNA decides to be dumb
    this.structures.unshift(mainStructure);
    // eslint-disable-next-line no-restricted-syntax
    _.each(this.structures, (model, index) =>
      model.set({
        // @ts-expect-error You can, but should not pass an HTMLElement to $.html
        smallSvg: $('<div>').html(model.getSvg(100, false))[0].innerHTML,
        index,
      })
    );

    this.$el.html(
      SecondaryStructureTabTemplate({
        models: this.structures,
        name: this.model.get('name').toLowerCase(),
        primer: this.model.get('primer'),
        primer2: this.model.get('primer2'),
        temperature: this.model.get('temperature'),
      })
    );
    return this;
  }
}
TabView.initClass();

export {TabView, OptionsView};
